"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "agosta": {
    "a8f32ff8": [{
      "hkey": "844c5ed2",
      "slug": "agosta",
      "name": "Agosta",
      "primary": true,
      "skipSearch": false
    }],
    "barco": [{
      "hkey": "844c5ed2",
      "slug": "agosta",
      "name": "Agosta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4336002e": [{
      "hkey": "844c5ed2",
      "slug": "agosta",
      "name": "Agosta",
      "primary": true,
      "skipSearch": false
    }],
    "cacino": [{
      "hkey": "844c5ed2",
      "slug": "agosta",
      "name": "Agosta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "34b105ee": [{
      "hkey": "844c5ed2",
      "slug": "agosta",
      "name": "Agosta",
      "primary": true,
      "skipSearch": false
    }],
    "pisciarello": [{
      "hkey": "844c5ed2",
      "slug": "agosta",
      "name": "Agosta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2b53d254": [{
      "hkey": "844c5ed2",
      "slug": "agosta",
      "name": "Agosta",
      "primary": true,
      "skipSearch": false
    }],
    "selve": [{
      "hkey": "844c5ed2",
      "slug": "agosta",
      "name": "Agosta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8bd92a69": [{
      "hkey": "844c5ed2",
      "slug": "agosta",
      "name": "Agosta",
      "primary": true,
      "skipSearch": false
    }],
    "valleberta": [{
      "hkey": "844c5ed2",
      "slug": "agosta",
      "name": "Agosta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;